<template>
  <div class="section">
    <h2 class="rtl is-size-1 has-text-centered mb-6">
      דוח עובד <span v-if="selectedAdmin">- {{ selectedAdmin }}</span
      ><span v-if="selectedDate">
        - ל: {{ $moment(selectedDate).format('DD/MM/YYYY') }}</span
      >
    </h2>
    <div class="columns">
      <div class="column is-3 is-offset-2">
        <h3 class="has-text-weight-bold ml-1 mb-4">Admin:</h3>
        <select @change="(e) => selectFilter('admin', e.target.value)">
          <option value="remove_filter">NOT SELECTED</option>
          <option
            v-for="option in dropdownAdmins"
            :selected="selectedAdmin == option.value"
            :key="option.value"
            :value="option.value">
            {{ option.text }}
          </option>
        </select>
      </div>
      <div class="column">
        <h3 class="has-text-weight-bold ml-5 mb-4">Date:</h3>
        <div class="is-flex is-align-items-center">
          <button @click="dayNextPrev(-1)" class="button is-info mx-5">
            Previous Day
          </button>
          <input
            dir="ltr"
            @input="pickDate"
            v-model="selectedDate"
            placeholder="20/03/2017"
            type="date" />
          <button @click="dayNextPrev(1)" class="button is-info mx-5">
            Next Day
          </button>
        </div>
      </div>
    </div>
    <div>
      <div v-if="!selectedAdmin">
        <p class="box m-6 has-text-centered has-text-danger is-size-3">
          Please Choose Admin
        </p>
      </div>
      <div v-else-if="!selectedDate">
        <p class="box m-6 has-text-centered has-text-danger is-size-3">
          Please Choose Date
        </p>
      </div>
      <div v-else class="box m-6">
        <table class="table is-fullwidth">
          <thead>
            <tr class="mx-6 px-6">
              <th class="has-text-centered">כמות</th>
              <th class="has-text-centered">קטגוריה</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(value, key, idx) in data" :key="idx">
              <td class="has-text-centered">{{ value.value }}</td>
              <td class="has-text-centered">{{ value.text }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

const WHITELIST = ['applicant_answered_phone', 'applicant_rejected', 'daily_breaks', 'done_alert', 'follow_up', 'offers_sent', 'strong', 'time_exceed', 'vetted']

export default {
  name: 'EmployeeReport',

  data () {
    return {
      selectedDate: this.$route.query.date,
      selectedAdmin: this.$route.query.admin,
      data: {}
    }
  },
  computed: {
    ...mapGetters('admins', ['dropdownAdmins']),
    arrDates () {
      // https://stackoverflow.com/questions/4413590/javascript-get-array-of-dates-between-2-dates
      var getDaysArray = function (s, e) {
        for (
          var a = [], d = new Date(s);
          d <= new Date(e);
          d.setDate(d.getDate() + 1)
        ) {
          a.push(new Date(d).toISOString().slice(0, 10))
        }
        return a
      }
      return getDaysArray(
        new Date(this.$moment().add(-30, 'days')),
        new Date()
      ).sort((a, b) => b.localeCompare(a))
    }
  },
  created () {
    this.getInformation()
  },
  methods: {
    pickDate (v) {
      this.selectFilter('date', v.target.value || undefined)
    },
    dayNextPrev (daysNumber) {
      if (!this.selectedDate) return
      const date = this.$moment(this.selectedDate, 'YYYY-MM-DD').add(
        daysNumber,
        'days'
      )
      this.selectFilter('date', date.format('YYYY-MM-DD'))
    },
    selectFilter (filter, value) {
      const params = { ...this.$route.query }
      const query = {
        ...params,
        [filter]: value == 'remove_filter' ? undefined : value
      }
      this.$router.push({ name: 'employee-report', query })
    },
    async getInformation () {
      const data = await this.$network_utils.getFeedReport({
        owner: this.selectedAdmin,
        date_from: this.$moment(this.selectedDate).format('YYYY-MM-DD'),
        date_to: this.$moment(this.selectedDate)
          .add(1, 'days')
          .format('YYYY-MM-DD')
      })
      this.data = Object.keys(data).filter(v => WHITELIST.includes(v)).reduce((prev, curr) => {
        prev[curr] = {
          value: data[curr][this.selectedAdmin],
          text: data[curr]['translate']
        }
        return prev
      }, {})
    }
  }
}
</script>
